import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-comms-orders-edit',
		path: '/admin/comms/send_orders/:id/edit',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_comms_orders_edit" */ './index'), {
			exportName: 'AdminCommsOrdersEdit',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['staff'],
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
